/**
 * Building Level System
 * Bronze: 0-500
 * Silver: 500-1500
 * Gold: 1500-3000
 * Hero: 3000+
 */

export const getLevelInfo = (points) => {
  if (points >= 3000) {
    return {
      name: 'Hero',
      nameGr: 'Ήρωας',
      color: '#9333ea', // purple-600
      bgColor: 'bg-purple-600',
      textColor: 'text-purple-600',
      borderColor: 'border-purple-600',
      min: 3000,
      max: Infinity,
      next: null,
    };
  }
  if (points >= 1500) {
    return {
      name: 'Gold',
      nameGr: 'Χρυσός',
      color: '#eab308', // yellow-500
      bgColor: 'bg-yellow-500',
      textColor: 'text-yellow-500',
      borderColor: 'border-yellow-500',
      min: 1500,
      max: 3000,
      next: 'Hero',
      nextGr: 'Ήρωας',
    };
  }
  if (points >= 500) {
    return {
      name: 'Silver',
      nameGr: 'Ασημένιος',
      color: '#9ca3af', // gray-400
      bgColor: 'bg-gray-400',
      textColor: 'text-gray-400',
      borderColor: 'border-gray-400',
      min: 500,
      max: 1500,
      next: 'Gold',
      nextGr: 'Χρυσός',
    };
  }
  return {
    name: 'Bronze',
    nameGr: 'Χάλκινος',
    color: '#92400e', // amber-800
    bgColor: 'bg-amber-800',
    textColor: 'text-amber-800',
    borderColor: 'border-amber-800',
    min: 0,
    max: 500,
    next: 'Silver',
    nextGr: 'Ασημένιος',
  };
};

/**
 * Calculate progress percentage within current level
 * @param {number} points - Current points
 * @returns {number} Progress percentage (0-100)
 */
export const getProgress = (points) => {
  const level = getLevelInfo(points);
  if (level.max === Infinity) return 100; // Hero level is maxed out
  
  const currentLevelPoints = points - level.min;
  const levelRange = level.max - level.min;
  return Math.min(100, (currentLevelPoints / levelRange) * 100);
};

/**
 * Get points needed to reach next level
 * @param {number} points - Current points
 * @returns {number} Points needed for next level (0 if max level)
 */
export const getPointsToNext = (points) => {
  const level = getLevelInfo(points);
  if (level.max === Infinity) return 0; // Already at max level
  return level.max - points;
};

/**
 * Get level icon emoji
 * @param {string} levelName - Level name (Bronze/Silver/Gold/Hero)
 * @returns {string} Emoji icon
 */
export const getLevelIcon = (levelName) => {
  switch (levelName) {
    case 'Hero':
      return '🏆'; // Trophy
    case 'Gold':
      return '🥇'; // Gold medal
    case 'Silver':
      return '🥈'; // Silver medal
    case 'Bronze':
      return '🥉'; // Bronze medal
    default:
      return '🎖️'; // Military medal
  }
};
